.close-btn-container {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 103;
}

.close-btn {
  cursor: pointer;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  padding: 14px;
}

.close-btn > svg {
  fill: var(--close-button-color, black);
}
